<template>
  <div class="text-left mb-15">
    <el-row>
      <el-col>
        <div class="delivery-type">
          <div v-if="agencyProduct == 'true'" class="produits-agence mb-40">
            <div class="text-left flex">
              <div>
                <h4 class="mb-10" style="font-weight: 900; color: #333333">
                  {{ $t("checkout.produitsdeagence") }}
                </h4>
              </div>
              <div class="ml-5 mt-10">
                <QuestionMark />
              </div>
            </div>
            <el-select
              v-model="selectedBranch"
              filterable
              remote
              reserve-keyword
              :placeholder="saqPlaceholder"
              :remote-method="remoteMethod"
              :no-match-text="noBranchFound"
              :no-data-text="noBranchFound"
              :class="'saq-branches'"
              @visible-change="handleDropdownVisibility"
              @change="validateBranchSelection"
              >
              <el-option
                v-for="item in saqBranchesOptions"
                :key="item.value"
                :label="item.addressLine + ', ' + item.label"
                :value="item">
              </el-option>
            </el-select>
            <div class="delivery-info" v-if="selectedBranch">
              <br>
              <span>{{selectedBranch.addressLine}}</span><br />
              <span>{{selectedBranch.label}}</span><br />
              <span>{{selectedBranch.number}}</span><br />
              <span>{{selectedBranch.phone}}</span><br />
            </div>
          </div>
          <div v-if="restaurantProduct == 'true'">
            <!-- <div class="text-left flex"> -->
              <div class="d-flex align-items-center">
                <h4 class="" style="font-weight: 900; color: #333333">
                  {{ $t("checkout.boutiqueProductsSubtitle") }}: 
                </h4>
                <span class="ml-5">{{ $t("checkout.pickUp") }}</span>
              </div>
            </div>
          <!-- </div> -->
        </div>
      </el-col>
      <el-col>
        <el-button :disabled="!selectedBranch" type="primary" class="ctaSubmit" @click="updateDeliveryType">
          {{ $t("checkout.nextStep") }}
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import deliveryAddressIcon from "@/assets/images/product/delivery-address-icon.png";
import pickupAddressIcon from "@/assets/images/product/pickup-address-icon.png";
import QuestionMark from "@/components/question-mark.vue";

export default {
  components: {
    QuestionMark,
  },
  props: {
    saqBranches: {
      default: [],
    },
  },
  data() {
    return {
      radio: 6,
      images: {
        deliveryIcon: {
          src: deliveryAddressIcon,
        },
        pickupIcon: {
          src: pickupAddressIcon,
        },
      },
      // branchPickupoptions: [
      //   {
          
      //   },
      // ],
      showAddress: null,
      branchPickup: "",
      agencyProduct: localStorage.getItem('agencyProduct'),
      restaurantProduct: localStorage.getItem('boutiqueProduct'),
      getCountrycode: localStorage.getItem('countryCode'),
      saqBranchesOptions: [],
      selectedBranch: null,
      errorMessage: "",
      list: [],
      loading: false,
      noBranchFound: this.$i18n.t("checkout.noBranchFound"),
    };
  },
  computed: {
    branchPickupoptions() {
      const option = [{
        value: this.getCountrycode == 'QC' ? "montreal" : 'toronto',
        label: this.getCountrycode == 'QC' ? "Montréal" : 'Toronto',
      }]
      return option;
    },
    saqPlaceholder() {
      return this.$i18n.t("checkout.produitsdeagenceText");
    }
  },
  mounted() {
      this.list = this.saqBranches.map(item => {
        return { value: item.id, label: item.city, number:item.number, phone:item.phone, addressLine:item.addressLine };
      });
    },
  methods: {
    updateDeliveryType() {
      this.$emit("emit-update-Delivery-Type");
    },
    branchPickupChange(selected) {
      this.showAddress = selected;
    },
    validateBranchSelection() {
    this.errorMessage = this.selectedBranch ? "" : this.$i18n.t("checkout.selectBranchError");
  },
    remoteMethod(query) {
      this.loading = false;
      this.saqBranchesOptions = this.list.filter(item => {
        const cityMatch = item.label.toLowerCase().includes(query.toLowerCase());
        const addressMatch = item.addressLine.toLowerCase().includes(query.toLowerCase());
        
        return addressMatch || cityMatch; // Match either city or address
      })
      .sort((a, b) => {
      // Extract numbers at the start of the address line
      const numberA = parseInt(a.addressLine);
      const numberB = parseInt(b.addressLine);

      // Fallback to label if number extraction fails
      if (isNaN(numberA) || isNaN(numberB)) {
        return a.label.localeCompare(b.label);
      }

      return numberA - numberB;
    });
    },
    handleDropdownVisibility(visible) {
    if (visible && this.saqBranchesOptions.length === 0) {
      this.remoteMethod(''); // call with empty string to load all data initially
    }
  }
  },
};
</script>

<style lang="scss">
.delivery-icon {
  width: 28px;
}
.pickup-icon {
  width: 18px;
}
.produitsdelaboutique-select-label {
  align-items: center;
  display: flex !important;
  color: #000;
}
.produitsdelaboutique-radio {
  .el-radio__inner {
    width: 10px;
    height: 10px;
  }
}
.produitsdelaboutique-select-input {
  .el-input__inner {
    text-align: left !important;
  }
}
.produitsdelaboutique-address-text {
  color: #000;
  line-height: 1.2;
}
.ctaSubmit {
  padding: 8px 20px !important;
  height: 40px;
  min-width: 30% !important;
}
.saq-branches{
  border-width: 1px;
  border-style: solid;
  border-color: rgb(218, 82, 77);
  .el-input__inner {
    text-align: left !important;
  }
}
.delivery-info {
  text-align: center;
  max-width: max-content;
}
</style>
